export default __webpack_public_path__ + "static/media/website.5d91cc7c.svg";